import * as ambassadorWixGatewaysEcomV1DeliveryRatesGateway from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.http.js';
import * as ambassadorWixGatewaysEcomV1DeliveryRatesGatewayTypes from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.types.js';
import * as ambassadorWixGatewaysEcomV1DeliveryRatesGatewayUniversalTypes from './gateways-ecom-v1-delivery-rates-gateway-delivery-solutions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getDeliverySolutions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixGatewaysEcomV1DeliveryRatesGatewayUniversalTypes.GetDeliverySolutionsRequest,
  ambassadorWixGatewaysEcomV1DeliveryRatesGatewayTypes.GetDeliverySolutionsRequest,
  ambassadorWixGatewaysEcomV1DeliveryRatesGatewayUniversalTypes.GetDeliverySolutionsResponse &
    ambassadorWixGatewaysEcomV1DeliveryRatesGatewayUniversalTypes.GetDeliverySolutionsResponseNonNullableFields,
  ambassadorWixGatewaysEcomV1DeliveryRatesGatewayTypes.GetDeliverySolutionsResponse &
    ambassadorWixGatewaysEcomV1DeliveryRatesGatewayTypes.GetDeliverySolutionsResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixGatewaysEcomV1DeliveryRatesGateway.getDeliverySolutions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/get-delivery-solutions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
